import { create } from "zustand";
import { UploadedImage } from "../Post/PostForm/PostFormModal.types";

type MediaFilesSlice = {
    images: UploadedImage[];
    isUploading: boolean;
    setImages: (images: UploadedImage[]) => void;
    setIsUploading: (value: boolean) => void;
};

export const useMediaFilesUploadInputStore = create<MediaFilesSlice>()(
    (set) => ({
        images: [],
        setImages: (images) => set({ images }),
        isUploading: false,
        setIsUploading: (isUploading) => {
            set({ isUploading });
        },
    }),
);
